import React, {Component} from 'react'
import {Modal, Button, Table} from 'antd'
import groovyManagementAPI from '../../../apis/groovyManagement'
import {EyeOutlined} from '@ant-design/icons'
import {toJS} from 'mobx'
import ViewModal from './ViewModal'
import {withTranslation} from 'react-i18next'

class FormModal extends Component {
  formRef = React.createRef()
  state = {
    tableData: [],
    viewModalVisible: false,
    id: null
  }

  componentDidMount() {
    const {id} = this.props
    groovyManagementAPI.ViewAction(id).then(res => {
      if (res.data.code === 0) {
        let result = res.data.data
        this.setState({
          tableData: result.versionList
        })
      }
    })
  }

  handleVer = (id) => {
    this.setState({
      viewModalVisible: true,
      id
    })
  }

  handleViewCancel = () => {
    this.setState({
      viewModalVisible: false
    })
  }

  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {verModalVisible, handleCancel, t} = this.props
    return (
      <>
        <Modal
          title={t(`groovyManagement.groovy`)}
          width="70%"
          closable={true}
          onCancel={() => { handleCancel('verModalVisible') }}
          visible={verModalVisible}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={null}
        >
          <Table className="searchResult" dataSource={toJS(this.state.tableData)} rowKey="id" pagination={false} rowClassName={this.getRowClassName} style={{margin: 0, padding: 0}}>
            <Table.Column title={t(`groovyManagement.id`)} dataIndex="id" key="id" ellipsis={true}/>
            <Table.Column title={t(`groovyManagement.creator`)} dataIndex="createUser" key="createUser" ellipsis={true}/>
            <Table.Column title={t(`groovyManagement.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
            <Table.Column width={150} align="center" title={t(`general.action`)} key="Action" render={(text, record) => (
              <>
                <Button type="link" icon={<EyeOutlined/>} onClick={() => {this.handleVer(record.id)}} title={t(`general.display`)}/>
              </>
            )}/>
          </Table>
        </Modal>
        {this.state.viewModalVisible ?
          <ViewModal handleViewCancel={this.handleViewCancel} id={this.state.id} viewModalVisible={this.state.viewModalVisible}/> : null}
      </>
    )
  }
}

export default withTranslation()(FormModal)
